/**
 * Shared runtime constants.
 * Single source of truth so timer duration and CSS animation can't drift.
 */
export const UNDO_TIMEOUT_MS = 5000;

/**
 * Marks a locale entry that exists only as scaffolding — the English string
 * copied into a locale file so translators can find outstanding work by
 * grepping. Shared with scripts/scaffold-translations.ts.
 *
 * The runtime treats a value carrying this prefix as untranslated and falls back
 * to English, so a scaffolded key never surfaces the marker to a user.
 */
export const PLACEHOLDER_PREFIX = '[NEEDS TRANSLATION] ';

/** A locale value that is safe to render instead of falling back to English. */
export function isRealTranslation(value: unknown): value is string {
  return typeof value === 'string'
    && value.trim().length > 0
    && !value.startsWith(PLACEHOLDER_PREFIX);
}
